module.exports = __webpack_public_path__ + "static/gallery-urban-indian-1-4797bfdb3f4250a6ed29ede8493c355b.jpg";